import { IconProps } from '../IconsTypes'

const FavouriteStoreIcon = ({
  width = 24,
  height = 24,
  viewBox = '0 0 30 31',
  color = 'none',
  className,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2 0.142578L22.4286 9.79972H15V0.142578H20.2Z"
        fill="#DBB300"
      />
      <path d="M9.8 0.142578L7.57143 9.79972H15V0.142578H9.8Z" fill="#FFD500" />
      <path
        d="M5.49995 1.09438L0.142822 9.79972H7.57139L9.79996 0.142578H7.20327C6.50875 0.142578 5.86395 0.502888 5.49995 1.09438Z"
        fill="#DBB300"
      />
      <path
        d="M24.5 1.09438L29.8572 9.79972H22.4286L20.2 0.142578H22.7967C23.4913 0.142578 24.136 0.502888 24.5 1.09438Z"
        fill="#FFD500"
      />
      <rect
        x="1.6272"
        y="13.5137"
        width="26.7429"
        height="17.0857"
        rx="2.6"
        fill="#70707C"
      />
      <path
        d="M0.142822 9.79883H7.57139V13.8845C7.57139 15.3205 6.40733 16.4845 4.97139 16.4845H2.74282C1.30688 16.4845 0.142822 15.3205 0.142822 13.8845V9.79883Z"
        fill="#DBB300"
      />
      <path
        d="M7.57141 9.79883H15V13.8845C15 15.3205 13.8359 16.4845 12.4 16.4845H10.1714C8.73547 16.4845 7.57141 15.3205 7.57141 13.8845V9.79883Z"
        fill="#FFD500"
      />
      <path
        d="M15 9.79883H22.4286V13.8845C22.4286 15.3205 21.2645 16.4845 19.8286 16.4845H17.6C16.1641 16.4845 15 15.3205 15 13.8845V9.79883Z"
        fill="#DBB300"
      />
      <path
        d="M22.4286 9.79883H29.8572V13.8845C29.8572 15.3205 28.6931 16.4845 27.2572 16.4845H25.0286C23.5926 16.4845 22.4286 15.3205 22.4286 13.8845V9.79883Z"
        fill="#FFD500"
      />
      <path
        d="M6.82812 20.0139C6.82812 19.2959 7.41015 18.7139 8.12812 18.7139H12.2138C12.9318 18.7139 13.5138 19.2959 13.5138 20.0139V30.5996H6.82812V20.0139Z"
        fill="#F5F5F5"
      />
      <rect
        x="17.9709"
        y="19.46"
        width="5.94286"
        height="5.2"
        rx="1.3"
        fill="#F5F5F5"
      />
    </svg>
  )
}

export default FavouriteStoreIcon
